import links from '@/constants/links'

export default {
    forms: {
        changePassword: [
            "currentPassword",
            "newPassword",
            "confirmNewPassword"
        ],
        sendGiftPoints: [
            "charName",
            "points",
        ],
        completeOAuthProfile: [
            "password",
            "username",
            "email",
            "confirmPassword"
        ],
        login: [
            "username",
            "password"
        ],
        register: [
            "username",
            "nickname",
            "email",
            "password",
            "confirmPassword",
        ],
        resetLink: [
            "email",
        ],
        resetPassword: [
            "email",
            "newPassword",
            "confirmNewPassword"
        ],
        rapidRegister: [
            "email",
        ]
    },
    routes: {
        logged: [
            links.routes.checkout.replace("/:provider?", "").replace("/:id?", ""),
            links.routes.checkoutCompleted,
            links.routes.checkoutCancelled,
            links.routes.profile,
            links.routes.profileOverview,
            links.routes.profileOAuthSetup,
            links.routes.profileTransactions,
            links.routes.profileCommunities,
            links.routes.profileDownloads,
            links.routes.profilePassword,
            links.routes.profileSettings,
            links.routes.gift,
            links.routes.giftPoints
        ],
        admin: [],
        guest: [
            links.routes.login,
            links.routes.register,
            links.routes.resetLink,
            links.routes.resetPassword.replace(":token", ""),
        ]
    }
}
